var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDrawerUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 20.088,
    viewBox: "0 0 24 20.088",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_679",
    "data-name": "Group 679",
    transform: "translate(0 0.088)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_643",
    "data-name": "Path 643",
    d: "M17,19V17a4,4,0,0,0-4-4H5a4,4,0,0,0-4,4v2",
    fill: "none",
    stroke: "#b6b6c7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_87",
    "data-name": "Ellipse 87",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(5 1)",
    strokeWidth: 2,
    stroke: "#b6b6c7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_644",
    "data-name": "Path 644",
    d: "M23,19V17a4.01,4.01,0,0,0-3-3.87",
    fill: "none",
    stroke: "#b6b6c7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_645",
    "data-name": "Path 645",
    d: "M16,1.13a4,4,0,0,1,0,7.75",
    fill: "none",
    stroke: "#b6b6c7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrawerUsers);
export default __webpack_public_path__ + "static/media/drawer-users.34a1f638237afb01c857fade84d96e38.svg";
export { ForwardRef as ReactComponent };